<template>
  <div class="common-header container clearfix">
    <div class="logo"></div>
    <div class="title" :title="title">{{ title }}</div>
  </div>
</template>
<script>
export default {
  name: "CommonHeader",
  props: {
    title: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="scss" scoped>
.common-header {
  background: url("~@/assets/images/entry/header_bg.jpg") repeat-x;
  height: 63px;

  .logo {
    width: 590px;
    height: 63px;
    float: left;
    background: url("~@/assets/images/entry/title.png") no-repeat;
  }

  .title {
    margin-right: 12px;
    width: 395px;
    height: 63px;
    line-height: 63px;
    color: #ffffff;
    text-align: right;
    font-size: 22px;
    float: right;
    background: url("~@/assets/images/entry/right.jpg") no-repeat right bottom;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
